import { render, staticRenderFns } from "./SalonWorkers.vue?vue&type=template&id=43f6f096&scoped=true"
import script from "./SalonWorkers.vue?vue&type=script&lang=ts"
export * from "./SalonWorkers.vue?vue&type=script&lang=ts"
import style0 from "./SalonWorkers.vue?vue&type=style&index=0&id=43f6f096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f6f096",
  null
  
)

export default component.exports